import {PassportResponse, PassportUserProps} from '@logistics-frontend/blocks/legacy'
import {AsyncStatus} from '@yandex-taxi/react-integration-api'
import {useEffect, useState} from 'react'

import {client} from '../../api.client'
import {AppConfig, useConfig} from '../../config'

type AsyncState = {
  data?: PassportUserProps
  status: AsyncStatus
  error?: Error
}

const toPassportProps = (config: AppConfig, response: PassportResponse): PassportUserProps => {
  return {
    passportHost: config.passport.host,
    avatarHost: config.passport.avatarsHost,
    accounts: response.accounts,
    canAddMore: response['can-add-more'],
    defaultUid: response.default_uid,
    returnPath: encodeURIComponent(window.location.href),
    service: config.passport.appID,
    yui: config.user.yandexUID,
  }
}

export const usePassportRequest = (): AsyncState => {
  const config = useConfig()
  const [state, setState] = useState<AsyncState>({
    status: AsyncStatus.INITIAL,
  })

  useEffect(() => {
    setState({
      status: AsyncStatus.PENDING,
    })

    return client({
      url: `${config.passport.apiHost}/all_accounts`,
      onSuccess: (response: PassportResponse) =>
        setState({
          status: AsyncStatus.SUCCESS,
          data: toPassportProps(config, response),
        }),
      onError: error =>
        setState({
          status: AsyncStatus.ERROR,
          error,
        }),
    })
  }, [config])

  return state
}
